module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114124_85_157.73f5492.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114124_85_157.jpg
// module id = ZN6M
// module chunks = 0